import { Table as BaseTable, TableContainer } from '@material-ui/core'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { irem } from '../../utils'

export type TableProps = {
}

const StyledTableContainer = styled(TableContainer)`
  .MuiTableCell-head {
      &:first-child {
          border-top-left-radius: ${irem(8)};
      }
      
      &:last-child {
          border-top-right-radius: ${irem(8)};
      }
  }
`

export const Table: React.FC<PropsWithChildren<TableProps>> = ({ children, ...props }) => {
  return (
    <StyledTableContainer>
      <BaseTable {...props}>
        {children}
      </BaseTable>
    </StyledTableContainer>
  )
}
